module.exports = __webpack_public_path__ + "img/1977-850x510-the-touch.aee98c0a.jpg";